
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import { ServerTableDetails } from "@/store/devices/types";
import { PaginatedSearchQueryParams } from "@/store/types";
import GenericTable, { TableHeader } from '../table/generic-table.vue';
import { AlarmPointsResponse } from "@/store/alarm-points/types";

@Component({
  components: {
    "generic-table": GenericTable
  }
})

export default class AlarmPointsTable extends Vue {
  @Prop({ type: Array }) public alarmsList: AlarmPointsResponse[];
  @Prop({ type: Number }) public totalAlarmCount: number;
  @Prop({ type: Boolean, default: true, required: false }) showTableSearch: boolean;
  @Prop({ type: String, default: null, required: false }) private searchQuery: string;

  private columns: TableHeader[] = [
		{
			title: "Title",
			key: "title",
			order: 1,
			sortOrder: 0,
			sortOrderReversed: false,
			description: "Device Name",
			searchable: true,
			visible: true,
			dataType: "string",
			isTermLabel: true,
			sortable: true,
			isSortedByDefault: true,
		},
  ]

  @Emit("openOnTest")
  private openOnTest(selectedRow: ServerTableDetails): ServerTableDetails {
    return selectedRow;
  }

  @Emit("fetchAlarms")
  public async updateData(paginatedSearchQueryParams?: PaginatedSearchQueryParams): Promise<PaginatedSearchQueryParams> {
    return paginatedSearchQueryParams;
  }
}
